<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14O7Udt/tc-custom/9781555848903.jpg?1728327019915" alt="This image is the cover for the book Place to Stand"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Place to Stand
      </h1>
      <p class="bookDescription body article font2">
        <b>The Pushcart Prize–winning poet’s memoir of his criminal youth and years in prison: a “brave and heartbreaking” tale of triumph over brutal adversity (<i>The Nation</i>).</b><br/>  <br/> Jimmy Santiago Baca’s “astonishing narrative” of his life before, during, and immediately after the years he spent in the maximum-security prison garnered tremendous critical acclaim. An important chronicle that “affirms the triumph of the human spirit,” it went on to win the prestigious 2001 International Prize (<i>Arizona Daily Star</i>).<br/>  <br/> Long considered one of the best poets in America today, Baca was illiterate at the age of twenty-one when he was sentenced to five years in Florence State Prison for selling drugs in Arizona. This raw, unflinching memoir is the remarkable tale of how he emerged after his years in the penitentiary—much of it spent in isolation—with the ability to read and a passion for writing poetry.<br/>  <br/> “Proof there is always hope in even the most desperate lives.” —<i>Fort Worth Star-Telegram</i><br/>  <br/> “A hell of a book, quite literally. You won’t soon forget it.” —<i>The San Diego U-T</i><br/>  <br/> “This book will have a permanent place in American letters.” —Jim Harrison, <i>New York Times</i>–bestselling author of <i>A Good Day to Die</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jimmy Santiago Baca
      </h2>
      
      <p class="authorDescription body article">Jimmy Santiago Baca was born in Santa Fe, New Mexico. He has written several books of poetry and a number of screenplays. His awards include the National Endowment of Poetry Award, Vogelstein Foundation Award, National Hispanic Heritage Award, Berkeley Regents Award, Pushcart Prize, Southwest Book Award, and American Book Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a162f154